import styled, { keyframes, css } from "styled-components";

// --- ANIMAÇÕES ---
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideInRight = keyframes`
  from { transform: translateX(20px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
`;

// --- LAYOUT DO MODAL ---
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(8px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.3s ease;
`;

export const ModalContainer = styled.div`
  background: #141414;
  width: 90%;
  max-width: 700px;
  height: 650px; /* Altura fixa para consistência */
  border-radius: 16px;
  border: 1px solid rgba(230, 170, 58, 0.3);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

// --- HEADER ---
export const ModalHeader = styled.div`
  background: #0f0f0f;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  button {
    background: transparent;
    border: none;
    color: #888;
    font-size: 20px;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      color: #fff;
    }
  }
`;

// --- STEPPER (Barra de Progresso) ---
export const StepperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
  background: #0f0f0f;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 40px;
    right: 40px;
    height: 2px;
    background: #333;
    z-index: 0;
    transform: translateY(-50%);
  }
`;

export const StepItem = styled.div`
  z-index: 1;
  background: #0f0f0f;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${(props) =>
      props.active ? "#e6aa3a" : props.completed ? "#e6aa3a" : "#222"};
    color: ${(props) => (props.active || props.completed ? "#000" : "#666")};
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid
      ${(props) =>
        props.active ? "#fff" : props.completed ? "#e6aa3a" : "#333"};
    transition: 0.3s;
  }

  span {
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 600;
    color: ${(props) => (props.active ? "#fff" : "#666")};
  }
`;

// --- CORPO DO CONTEÚDO ---
export const ModalBody = styled.div`
  flex: 1;
  padding: 30px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #333;
    border-radius: 3px;
  }
`;

export const StepContent = styled.div`
  animation: ${slideInRight} 0.4s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Title = styled.h3`
  font-size: 18px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 500;
  span {
    color: #e6aa3a;
    font-weight: bold;
  }
`;

// --- COMPONENTES DE FORMULÁRIO ---
export const SearchInput = styled.input`
  width: 100%;
  padding: 16px;
  background: #000;
  border: 1px solid #333;
  box-sizing: border-box;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
  margin-bottom: 20px;
  outline: none;
  transition: 0.3s;

  &:focus {
    border-color: #e6aa3a;
    box-shadow: 0 0 0 2px rgba(230, 170, 58, 0.2);
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 350px;
  overflow-y: auto;
  padding-right: 5px;
`;

export const CardItem = styled.div`
  background: ${(props) =>
    props.selected ? "rgba(230, 170, 58, 0.15)" : "#1a1a1a"};
  border: 1px solid ${(props) => (props.selected ? "#e6aa3a" : "#333")};
  padding: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background: ${(props) =>
      props.selected ? "rgba(230, 170, 58, 0.2)" : "#252525"};
    border-color: ${(props) => (props.selected ? "#e6aa3a" : "#555")};
    transform: translateY(-2px);
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  strong {
    color: #fff;
    font-size: 15px;
  }
  span {
    color: #888;
    font-size: 13px;
  }
  .price {
    color: #e6aa3a;
    font-weight: bold;
    font-size: 14px;
  }
`;

// --- GRID PARA OPÇÕES ---
export const OptionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 20px;
`;

export const OptionCard = styled.div`
  background: ${(props) => (props.selected ? "#e6aa3a" : "#1a1a1a")};
  color: ${(props) => (props.selected ? "#000" : "#fff")};
  border: 1px solid ${(props) => (props.selected ? "#e6aa3a" : "#333")};
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  transition: 0.3s;

  h4 {
    margin: 0 0 5px 0;
    font-size: 16px;
  }
  p {
    margin: 0;
    font-size: 12px;
    opacity: 0.8;
  }

  &:hover {
    border-color: #e6aa3a;
    transform: scale(1.02);
  }
`;

// --- RESUMO ---
export const SummaryBox = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 8px;
  border: 1px dashed #444;
  margin-top: 10px;

  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;

    span:first-child {
      color: #888;
    }
    span:last-child {
      color: #fff;
      font-weight: 600;
      text-align: right;
    }
  }

  .total {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #444;
    color: #e6aa3a;
    font-size: 16px;
  }
`;

// --- FOOTER / BOTÕES ---
export const ModalFooter = styled.div`
  padding: 20px 30px;
  border-top: 1px solid #222;
  display: flex;
  justify-content: space-between;
  background: #0f0f0f;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  border: none;
  transition: 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;

  /* Tipos de Botão */
  ${(props) =>
    props.secondary &&
    css`
      background: transparent;
      border: 1px solid #444;
      color: #fff;
      &:hover {
        background: #222;
      }
    `}

  ${(props) =>
    props.primary &&
    css`
      background: linear-gradient(135deg, #e6aa3a, #b88a2d);
      color: #000;
      &:hover {
        filter: brightness(1.1);
        transform: translateY(-1px);
      }
      &:disabled {
        background: #333;
        color: #555;
        cursor: not-allowed;
        transform: none;
        filter: none;
      }
    `}
`;
